import React from "react";
import Layout from "../components/layout/Layout";
import ProposalList from "../components/proposals/ProposalList";

const ProposalsPage = () => {
  return (
    <Layout title="All Proposals">
      <ProposalList />
    </Layout>
  );
};

export default ProposalsPage;
